import { backendAPI } from 'api';
import { call, put } from 'redux-saga/effects';
import {
  updatePaymentSettingSuccess,
  updatePaymentSettingFailed,
} from '../actions';

export default function* handleUpdatePaymentSetting({ payload }) {
  try {
    const data = yield call(
      backendAPI.updatePaymentSetting,
      payload.id,
      payload.data,
    );

    yield put(updatePaymentSettingSuccess(data));
  } catch (e) {
    yield put(updatePaymentSettingFailed(e));
  }
}
